(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('percentageIt', kebabCase);

    function kebabCase(CommonHelper) {
        return function(input, max) {
            input = parseInt(input) || 0;
            if (CommonHelper.isEmpty(max)) {
                return input;
            }
            max = parseInt(max)|| 100;

            var percentage = (input/max) * 100;
            return (Math.round(percentage * 100) / 100) + '%';
        }
    }
})();